import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { LinearProgress, styled, Typography, Box } from '@mui/material';
import { InfoCard } from '@/components/shared/info-card';
import type { Lesson } from '@/data/corporate-university/interfaces';

const getProgress = (lesson: Lesson) =>
  lesson?.lessons_progresses?.[0]?.progress || 0;

const StyledContainer = styled(Box)<{ isCurrent: boolean }>(
  ({ theme, isCurrent }) => ({
    backgroundColor: isCurrent ? theme.palette.neutral[100] : 'transparent',
    borderRadius: 0,
  })
);

interface LessonItemProps {
  lesson: Lesson;
  isCurrent: boolean;
  onClick: () => void;
}

export const LessonItem = ({ lesson, isCurrent, onClick }: LessonItemProps) => {
  const Icon =
    lesson.type === 'video' ? PlayCircleOutlineIcon : PictureAsPdfIcon;

  return (
    <StyledContainer isCurrent={isCurrent}>
      <InfoCard icon={Icon} onClick={onClick} withBorder>
        <Typography
          color={isCurrent ? 'primary' : 'text.primary'}
          fontWeight={isCurrent ? 'bold' : 'semibold'}
        >
          {lesson.title}
        </Typography>
        <Typography fontWeight="semibold">
          Progresso: {getProgress(lesson)}%
        </Typography>
        <LinearProgress
          value={getProgress(lesson)}
          variant="determinate"
          sx={{ mt: 2 }}
        />
      </InfoCard>
    </StyledContainer>
  );
};
